<template>
    <div class="dd-m-quiz--result">
        <!-- <div class="dd-m-quiz__thumb" v-if="needscope.image && !offline">
            <picture class="dd-m-quiz__img">
                <source :srcset="needscope.image.desktop" media="(min-width: 1280px)"/>
                <source :srcset="needscope.image.tablet" media="(min-width: 768px)"/>
                <img :srcset="needscope.image.mobile" :alt="needscope.definition"/>
            </picture>
        </div>

        <div class="dd-m-quiz__content has-padding">
            <div class="dd-m-quiz__step">
                <h1 class="dd-m-quiz__title dd-m-quiz__title--res">{{needscope.description}}</h1>
                <a
                    @click.prevent="redirect"
                    :title="getTranslateString('Learn more')"
                    class="dd-m-quiz__step__button dd-m-button dd-m-button--default dd-m-button--assertive"
                >{{getTranslateString('Learn more')}}</a>

                <a title="Compartilhar"
                   class="dd-m-quiz__step__button dd-m-button dd-m-button--default dd-m-button--assertive"
                   @click.prevent="present">
                    {{getTranslateString('Share your result')}}
                </a>
            </div>
        </div> -->
    </div>
</template>
<script>
    export default {
        name: "needscope-result",
        props: ["needscope", "offline"],
        methods: {
            redirect() {
                if (this.offline) {
                    PubSub.publish("openIdealsOffline", this.needscope.id);
                } else {
                	var url = `/perfumes-ideais/${this.needscope.id}`+(this.needscope.gender?"/"+this.needscope.gender:"");
                	if(language_is_default){
                    	location.href = url;
                    }else{
                    	location.href = `/${language}`+url;
                    }
                }
            },
            present() {
                const url = `${location.origin}/perfumes-ideais/${this.needscope.id}`;
                PubSub.publish(`modal-share-open`, url);
            }
        },
        created(){
            this.redirect()
        }
    };
</script>



// WEBPACK FOOTER //
// resources/site/js/components/quiz/needscope-result.vue